import React from "react";
import { Modal, Button } from "react-bootstrap";

const CommonModal = ({ show, onClose, title, children, size = "lg" }) => {
  return (
    <Modal show={show} onHide={onClose} size={size}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommonModal;
